export default {"src":"/_next/static/media/disc-wheels.703f5c65.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};